namespace RioERP.Orders {
    export interface WebsiteOrderProductsForm {
        OrderId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
        Qty: Serenity.IntegerEditor;
        SkuCode: Serenity.StringEditor;
        MappingStatus: Serenity.EnumEditor;
        EOpens: Serenity.IntegerEditor;
        EWatchTime: Serenity.IntegerEditor;
        EValidity: Serenity.IntegerEditor;
        EValidityType: Serenity.IntegerEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowedDevices: Serenity.StringEditor;
        AccessStatus: Serenity.EnumEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        HasPendrive: Serenity.BooleanEditor;
        IsTemplateSerialKey: Serenity.BooleanEditor;
        Islive: Serenity.BooleanEditor;
        SerialkeyStatus: Serenity.IntegerEditor;
        AttributeXml: Serenity.StringEditor;
    }

    export class WebsiteOrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.WebsiteOrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WebsiteOrderProductsForm.init)  {
                WebsiteOrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DateEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(WebsiteOrderProductsForm, [
                    'OrderId', w0,
                    'ProductId', w0,
                    'Qty', w1,
                    'SkuCode', w2,
                    'MappingStatus', w3,
                    'EOpens', w1,
                    'EWatchTime', w1,
                    'EValidity', w1,
                    'EValidityType', w1,
                    'ValidTill', w4,
                    'TotalAllowedDuration', w1,
                    'AllowedDevices', w2,
                    'AccessStatus', w3,
                    'HasBooks', w5,
                    'HasCourier', w5,
                    'HasPendrive', w5,
                    'IsTemplateSerialKey', w5,
                    'Islive', w5,
                    'SerialkeyStatus', w1,
                    'AttributeXml', w2
                ]);
            }
        }
    }
}
